import { BookOpenCheckIcon, BriefcaseIcon, CalculatorIcon, CircleHelpIcon, WrenchIcon } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export type Bonus = {
  number: string;
  title: string;
  description: string;
  icon: LucideIcon;
};

export const bonuses: Bonus[] = [
  {
    number: '1',
    title: '100 Solar PV Calculation Exercises with Step-by-Step Solutions',
    description: 'Electrical, radiation, sizing, inverter, battery, performance calculations.',
    icon: CalculatorIcon,
  },
  {
    number: '2',
    title: 'Solar Technical Dictionary: 250 Essential Terms',
    description: 'Complete technical reference for solar and photovoltaic terminology.',
    icon: BookOpenCheckIcon,
  },
  {
    number: '3',
    title: '75 Solar PV Troubleshooting Scenarios & Solutions',
    description: 'Panels, inverters, batteries, faults, monitoring, hybrid systems.',
    icon: WrenchIcon,
  },
  {
    number: '4',
    title: '150 Solar Technical Questions with Explained Answers',
    description: 'Fundamentals, components, design, installation, maintenance, advanced topics.',
    icon: CircleHelpIcon,
  },
  {
    number: '5',
    title: '30 Practical Solar PV Project Case Studies',
    description: 'Residential, commercial, off-grid, hybrid, optimization scenarios.',
    icon: BriefcaseIcon,
  },
];
